import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    thankYouMessage = "thankYouMessage",
    thankYouHeader = "thankYouHeader",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.thankYouMessage]: string;
        [fields.thankYouHeader]: string;
    };
}

type Props = OwnProps;

export interface SurThankYouStyles {
    heading?: InjectableCss;
    thanksMessage?: InjectableCss;
}

export const thankYouStyles: SurThankYouStyles = {
    heading: {
        css: css`
            margin-bottom: 16px;
            color: ${getColor("primary")};
            line-height: 42px;
            font-size: 36px;
            font-weight: 600;
            font-family: "Mulish";
            text-align: center;
        `,
    },
    thanksMessage: {
        css: css`
            margin-bottom: 16px;
            line-height: 38px;
            font-size: 30px;
            font-weight: 400;
            font-family: "Mulish";
            text-align: center;
            margin-bottom: 16px;
            text-align: center;
        `,
    },
};

const ThankYou = ({ fields }: Props) => {
    const [styles] = useState(() => mergeToNew(thankYouStyles, {}));

    return (
        <>
            <Typography {...styles.heading} as="h1">
                {fields.thankYouHeader}
            </Typography>

            <Typography {...styles.thanksMessage} as="p">
                {fields.thankYouMessage}
            </Typography>
        </>
    );
};

const definition: WidgetDefinition = {
    group: "Basic",
    displayName: "ThankYou",
    fieldDefinitions: [
        {
            name: fields.thankYouHeader,
            displayName: "Thank You Header",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
        },
        {
            name: fields.thankYouMessage,
            displayName: "Thank You Message",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
        },
    ],
};

const widgetModule: WidgetModule = {
    component: ThankYou,
    definition,
};

export default widgetModule;
